import PropTypes from "prop-types"
import MetaTags from "react-meta-tags"
import React, { useState } from "react"
import { Row, Col, CardBody, Card, Alert, Container } from "reactstrap"
import { useSelector, useDispatch } from "react-redux"
import { withRouter, Link } from "react-router-dom"
import { AvForm, AvField } from "availity-reactstrap-validation"

// actions
import { loginUser } from "../../store/actions"
import logo from "assets/images/logos/2.png"

const Login = props => {
  const dispatch = useDispatch()
  const [awb, setAwb] = useState("")

  const url = document.URL
  const urlParts = url.split("/")
  const lastPart = urlParts[3]

  const { error } = useSelector(state => ({
    error: state.Login.error,
  }))

  // handleValidSubmit
  const handleValidSubmit = (event, values) => {
    dispatch(
      loginUser(
        {
          ...values,
          login_type: lastPart ? lastPart.toLocaleLowerCase() : "login",
        },
        props.history
      )
    )
  }

  return (
    <React.Fragment>
      <MetaTags>
        <title>Login | {process.env.REACT_APP_TITLE}</title>
      </MetaTags>
      <div className="home-btn d-none d-sm-block">
        <Link to="/" className="text-dark">
          <i className="fas fa-home h2" />
        </Link>
      </div>
      <div className="account-pages my-5 pt-sm-5">
        <Container>
          <a
            href="/admin"
            role="button"
            className="btn btn-primary"
            style={{ position: "absolute", right: "71px", top: "46px" }}
          >
            Login as Admin
          </a>

          <Row className="justify-content-center">
            <Col md={8} lg={6} xl={5}>
              <div className="input-group mb-3">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter AWB Number"
                  onChange={e => setAwb(e.target.value)}
                />
                <button
                  className="btn btn-primary"
                  style={{ width: "36px" }}
                  type="button"
                  onClick={() => {
                    if (awb != "") {
                      window.location.href = `/track/${awb}`
                    }
                  }}
                >
                  <i className="fas fa-arrow-right"></i>
                </button>
              </div>
            </Col>
          </Row>
          <Row className="justify-content-center">
            <Col md={8} lg={6} xl={5}>
              <Card className="overflow-hidden">
                <div className="bg-primary bg-soft">
                  <Row>
                    <Col>
                      <div className="text-primary p-4">
                        <h5 className="text-primary">Welcome Back !</h5>
                        <p>
                          Sign in to continue to{" "}
                          {`${
                            lastPart == "admin" ? "Admin  Panel" : "Your Panel"
                          }`}
                          .
                        </p>
                      </div>
                    </Col>
                  </Row>
                </div>
                <CardBody className="pt-0">
                  <div>
                    <Link to="/" className="auth-logo-light">
                      <div className="avatar-md profile-user-wid mb-4">
                        <span className="avatar-title rounded-circle bg-light">
                          <img src={logo} alt="" height="34" />
                        </span>
                      </div>
                    </Link>
                  </div>
                  <div className="p-2">
                    <AvForm
                      className="form-horizontal"
                      onValidSubmit={(e, v) => {
                        handleValidSubmit(e, v)
                      }}
                    >
                      {error ? <Alert color="danger">{error}</Alert> : null}

                      <div className="mb-3">
                        <AvField
                          name="email"
                          label={`${
                            lastPart == "admin" ? "Email" : "Phone Number"
                          }`}
                          value=""
                          className="form-control"
                          placeholder={`${
                            lastPart != "admin"
                              ? "Enter phone number"
                              : "Enter email"
                          }`}
                          type={`${lastPart != "admin" ? "number" : "email"}`}
                          required
                        />
                      </div>

                      <div className="mb-3">
                        <AvField
                          name="password"
                          label="Password"
                          value=""
                          type="password"
                          required
                          placeholder="Enter Password"
                        />
                      </div>

                      <div className="mt-3 d-grid">
                        <button
                          className="btn btn-primary btn-block"
                          type="submit"
                        >
                          Log In
                        </button>
                      </div>

                      <div className="mt-4 text-center">
                        <Link to="/forgot-password" className="text-muted">
                          <i className="mdi mdi-lock me-1" />
                          Forgot your password?
                        </Link>
                      </div>
                    </AvForm>
                  </div>
                </CardBody>
              </Card>
              <div className="mt-5 text-center">
                <p>
                  © {new Date().getFullYear()} ExpressFly. Crafted with{" "}
                  <i className="mdi mdi-heart text-danger" /> by
                  catchysystem.com
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default withRouter(Login)

Login.propTypes = {
  history: PropTypes.object,
}
